
export default function WhatsAppCTA() {
  return (
    <section id="contato" className="py-24 bg-gradient-to-br from-yellow-500 via-yellow-400 to-yellow-500 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-black rounded-full blur-2xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-black rounded-full blur-2xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-black rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        <div className="w-20 h-20 bg-black rounded-full flex items-center justify-center mx-auto mb-8">
          <i className="ri-whatsapp-line text-5xl text-yellow-500"></i>
        </div>
        
        <h2 className="text-4xl md:text-6xl font-bold text-black mb-6">
          Proteja Seu Veículo Agora!
        </h2>
        
        <p className="text-xl md:text-2xl text-black/80 mb-10 max-w-3xl mx-auto">
          Fale conosco pelo WhatsApp e garanta a segurança do seu veículo com o melhor rastreamento do mercado
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a
            href="https://wa.me/5511954662476"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-black text-yellow-500 px-10 py-5 rounded-xl text-xl font-bold hover:bg-gray-900 transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-3xl"></i>
            Falar no WhatsApp
          </a>
          <a
            href="tel:+5511954662476"
            className="inline-flex items-center gap-3 bg-white/20 backdrop-blur-sm text-black px-10 py-5 rounded-xl text-xl font-bold hover:bg-white/30 transition-all border-2 border-black/20 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-2xl"></i>
            Ligar Agora
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-black/10 backdrop-blur-sm rounded-xl p-6 border border-black/20">
            <i className="ri-time-line text-4xl text-black mb-3"></i>
            <h3 className="font-bold text-black text-lg mb-2">Atendimento Rápido</h3>
            <p className="text-black/80 text-sm">Resposta em minutos</p>
          </div>
          
          <div className="bg-black/10 backdrop-blur-sm rounded-xl p-6 border border-black/20">
            <i className="ri-calendar-check-line text-4xl text-black mb-3"></i>
            <h3 className="font-bold text-black text-lg mb-2">Instalação em 72h</h3>
            <p className="text-black/80 text-sm">Agendamento flexível</p>
          </div>
          
          <div className="bg-black/10 backdrop-blur-sm rounded-xl p-6 border border-black/20">
            <i className="ri-money-dollar-circle-line text-4xl text-black mb-3"></i>
            <h3 className="font-bold text-black text-lg mb-2">Melhor Preço</h3>
            <p className="text-black/80 text-sm">Planos a partir de R$ 59,90/mês</p>
          </div>
        </div>
      </div>
    </section>
  );
}
